import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { observer } from 'mobx-react';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainBannerSlide from '@organisms/main/MainBannerSlide';
import SectionTopContents from '@organisms/main/mobile/section/TopSections';
import SectionWithBTS from '@organisms/main/mobile/section/WithBTS';
import SectionCoupon from '@organisms/main/section/Coupon';
import SectionMedia from '@organisms/main/mobile/section/Media';
import SectionIntroduce from '@organisms/main/partial/Introduce';

const MobileMain = () => {
  const { i18n } = useTranslation();
  const introRef = useRef();
  const withBTSRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);

  useEffect(() => {
    let query = queryString.parse(location.search);

    if (query.menu === 'introduce') {
      window.scrollBy({
        top: introRef.current?.getBoundingClientRect().top,
        left: 0,
        behavior: 'smooth',
      });
    }

    if (query.menu === 'withBTS') {
      window.scrollBy({
        top: withBTSRef.current?.getBoundingClientRect().top - 30,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [location, query]);

  useEffect(() => {}, []);

  return (
    <div className="font-nuniSans">
      <div className="z-50 relative">
        <MainBannerSlide />
      </div>
      <SectionTopContents />
      <SectionIntroduce introRef={introRef} />
      <SectionMedia />
      <SectionWithBTS btsRef={withBTSRef} />
      <SectionCoupon />
    </div>
  );
};

export default observer(MobileMain);
